
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m27.197 9.76-10.75-5.375a1.008 1.008 0 0 0-.894 0L4.802 9.76a.995.995 0 0 0-.552.894v4.942a.994.994 0 0 0 .474.85.997.997 0 0 0 .973.044L7 15.84V26.25A1.752 1.752 0 0 0 8.75 28h14.5A1.752 1.752 0 0 0 25 26.25V15.839l1.303.651a.995.995 0 0 0 .973-.044.994.994 0 0 0 .474-.85v-4.942a.997.997 0 0 0-.553-.894ZM13.75 26.5v-5.75a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25v5.75h-4.5Zm9.75-.25a.25.25 0 0 1-.25.25h-3.5v-5.75A1.752 1.752 0 0 0 18 19h-4a1.752 1.752 0 0 0-1.75 1.75v5.75h-3.5a.25.25 0 0 1-.25-.25V15.089l7.5-3.75 7.5 3.75V26.25Z"}})])
          )
        }
      }
    